module.exports = __webpack_public_path__ + "static/media/act-1.7f64a175.pdf";